import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import SectionLabel from "../site/SectionLabel";
import { HOME_SECTIONS } from "@/constants/testIds";
import { CORE_SERVICES_HOME } from "@/lib/data";

export default function Services() {
  return (
    <section
      data-testid={HOME_SECTIONS.services}
      className="relative bg-ink-900 py-28 lg:py-40"
    >
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-5">
            <SectionLabel number="05">Services</SectionLabel>
            <h2 className="mt-6 font-display text-5xl leading-[0.98] tracking-tighter text-ivory lg:text-7xl">
              Six capabilities.<br />
              <span className="italic text-gold">One growth partner.</span>
            </h2>
            <Link
              to="/services"
              className="group mt-10 inline-flex items-center gap-3 font-sans text-[12px] uppercase tracking-widest text-gold hover:text-ivory transition-colors"
            >
              Explore all services
              <span className="h-px w-8 bg-current transition-all group-hover:w-12" />
            </Link>
          </div>

          <div className="lg:col-span-7">
            <div className="border-y border-ivory/[0.06]">
              {CORE_SERVICES_HOME.map((s, i) => (
                <motion.div
                  key={s.number}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.6, delay: i * 0.06, ease: [0.76, 0, 0.24, 1] }}
                >
                  <Link
                    to={`/services/${s.slug}`}
                    className="group flex items-start justify-between gap-8 border-b border-ivory/[0.06] py-8 last:border-b-0 lg:py-10"
                  >
                    <div className="font-display text-3xl italic text-gold lg:text-4xl">
                      {s.number}
                    </div>
                    <div className="flex-1">
                      <h3 className="font-display text-3xl leading-tight tracking-tight text-ivory transition-colors group-hover:text-gold lg:text-4xl">
                        {s.title}
                      </h3>
                      <p className="mt-3 max-w-lg font-sans text-sm leading-relaxed text-ivory-muted lg:text-base">
                        {s.body}
                      </p>
                    </div>
                    <ArrowRight
                      size={18}
                      className="mt-2 shrink-0 text-ivory-muted transition-all duration-300 group-hover:translate-x-1 group-hover:text-gold"
                    />
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
